/* tslint:disable */
/** @jsx jsx */
import { jsx } from '@emotion/core';
import React, { useState, useEffect, memo } from 'react';
import Modal from 'react-modal';
import CircularProgress from '@material-ui/core/CircularProgress';
import Box from '@material-ui/core/Box';
import { useHistory } from 'react-router-dom';
import { domainPath } from '../App';
import { KeyUpService } from '../Services/KeyUpService';

const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        width: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        height: 'auto',
        padding: '50px',
        boxShadow: ' 12px 12px 15px rgb(204, 204, 204)',

    }
};

const IdealTimeProgressComponent = (props) => {
    const history = useHistory();
    
    useEffect(() => {
         const { Config, subConfig } = KeyUpService.getConfSubConf(props.location.pathname);        
             setTimeout(() => {
                   history.push(`/${domainPath}/new-client/config=${Config}&subConfig=${subConfig}`);
                }, 2000)
        
        }, []);

        return null;

    // return (
    //      <Modal
    //             isOpen={true}
    //             ariaHideApp={false}
    //             //onRequestClose={() => closeModal(false)}
    //             style={customStyles}
    //             contentLabel="Alert Message"
    //         >
    //             <div style={{ display: 'flex', justifyContent: 'center' }}>
    //             <Box sx={{ position: "relative", display: "inline-flex", justifyContent:'center' }}>
    //                  <CircularProgress color="inherit"  />
    //             </Box>
    //             </div>
    //             <div>
    //                     <strong>Your data submitted. You have been redirecting to new page...</strong>
    //                 </div>
    //         </Modal>
    // );
};

export default memo(IdealTimeProgressComponent);
